import { useNavigate } from 'react-router-dom';

import useTranslation from '../utils/useTranslation';
import Header from './Header';
import Footer from './Footer';
import GallerySection from './sections/GallerySection';

export default function GallerySection_Page() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigate = (sectionId) => {
    if (sectionId === 'home') {
      navigate('/');
      return;
    }
    if (sectionId === 'about' || sectionId === 'laws') return;
    navigate('/', { state: { scrollTo: sectionId } });
  };

  return (
    <div className="news-list-page gallery-page">
      <Header active="gallery" onNavigate={handleNavigate} />

      <main className="container news-list-page-main">
        <header className="news-section-head">
          <h2 className="news-section-title">{t('gallery_title')}</h2>
          <p className="news-section-desc">{t('gallery_subtitle')}</p>
        </header>

        <GallerySection
          limit={Infinity}
          showHeading={false}
          showViewAll={false}
          pageMode
        />
      </main>

      <Footer />
    </div>
  );
}
